var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":_vm.viewBox,"fill":_vm.iconColor}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }